export const KAMELEOON = {
  SITE_CODE: 'iw31avyafw',
  CUSTOM_DATA: {
    SP_APP_ID: 'sp_app_id',
    SP_DOMAIN_USERID: 'sp_domain_userid',
    SP_DOMAIN_SESSIONID: 'sp_domain_sessionid',
  },
} as const;

export enum KameleoonDomains {
  Development = 'local.design-system.ca',
  Staging = 'uat-shop.shoppersdrugmart.ca',
  Production = 'shoppersdrugmart.ca',
}

export enum KamErrors {
  Init = 'initialize',
  WarehouseKey = 'getWarehouseKey',
}

export const KAMELEOON_FEATURE_FLAGS = {
  ENABLE_SEARCH_TYPEAHEAD: 'enable_m6_search_typeahead',
  ENABLE_SRP_FEEDBACK: 'sdm-web-srp-relevance-feedback',
};

